import React,{useState,useEffect,useRef} from 'react'
import axios from "axios";
import { BASE_URL } from 'apiConfig';


export default function useEtfHoldings(tickerSel) {
    const [holdingsAll, setGeneralData] = useState([]);
    const [loadingHoldingsAll, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
       getData();

    }, [tickerSel]);
    
    async function getData() {
      setLoading(true);
      try {
        const response = await axios.get(`${BASE_URL}/holdingsAll/`, {
          params: {
            ticker: JSON.stringify([tickerSel]),
          },
        });
        setGeneralData(response.data);
        
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
    
    return {holdingsAll,loadingHoldingsAll}
}
